export default class extends Controller {
  static targets = ['editor'];

  connect() {
    this.disabled && this.disableEditor();
    this.focusOnConnect && this.editorTarget.focus();
  }

  disableEditor() {
    this.editorTarget.contentEditable = false;
    this.editorTarget.style.background = '#e6e6e6';
  }

  //
  // GETTERS AND SETTERS
  //

  get disabled() {
    return [true, 'true', 1, '1'].includes(this.data.get('disabled'));
  }

  get focusOnConnect() {
    return [true, 'true', 1, '1'].includes(this.data.get("focus-on-connect"));
  }
};



// WEBPACK FOOTER //
// ./app/components/forms/fields/assets/javascript/forms-fields-simple-wysiwyg-controller.js